import { inject, observer } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { UiStore, PharmacyDetailedStore } from '../../store';
import { RouteComponentProps } from 'react-router-dom';
import { Card } from '@blueprintjs/core';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import MultiCalendarsForComparison from '../common/calendar/MultiCalendarsForComparison';
import styled from '@emotion/styled';
import { css } from 'emotion';

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const CardStyle = css({
  height: '100%',
  '& .bp3-tabs': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '& .bp3-tab-panel': {
    flex: 1,
  },
  '& .ag-theme-balham': {
    width: '100%',
  },
});

interface CalendarComparisonPageProps extends RouteComponentProps<{ pharmacyId: string }> {
  getPharmacyById: (id: number) => any;
  UiStore?: Instance<typeof UiStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
}

interface CalendarComparisonPageState {
  selectedFirstPharmacyId: number | undefined;
  selectedSecondPharmacyId: number | undefined;
}

@inject('UiStore')
@inject('PharmacyDetailedStore')
@observer
class CalendarComparisonPage extends React.Component<
  CalendarComparisonPageProps & WithTranslateProps,
  CalendarComparisonPageState
> {
  state = {
    selectedFirstPharmacyId:
      this.props.UiStore!.multiCalendarFirstPharmacyId !== undefined
        ? this.props.UiStore!.multiCalendarFirstPharmacyId
        : this.props.UiStore!.lastSelectedPharmacy,
    selectedSecondPharmacyId: this.props.UiStore!.multiCalendarSecondPharmacyId,
  };

  onFirstPharmacyIdChanged = (pharmacyId: number) => {
    this.props.PharmacyDetailedStore!.getByIdWithDetails(pharmacyId);
    this.props.UiStore!.setMultiCalendarFirstPharmacyId(pharmacyId);
    this.setState({ selectedFirstPharmacyId: pharmacyId });
  };

  onSecondPharmacyIdChanged = (pharmacyId: number) => {
    this.props.PharmacyDetailedStore!.getByIdWithDetails(pharmacyId);
    this.props.UiStore!.setMultiCalendarSecondPharmacyId(pharmacyId);
    this.setState({ selectedSecondPharmacyId: pharmacyId });
  };

  render() {
    return (
      <MainSectionLayout>
        <Container>
          <Card className={CardStyle.toString()}>
            <MultiCalendarsForComparison
              startingPharmacy={this.state.selectedFirstPharmacyId}
              startingSecondPharmacy={this.state.selectedSecondPharmacyId}
              onFirstPharmacyIdChanged={this.props.UiStore!.setMultiCalendarFirstPharmacyId}
              onSecondPharmacyIdChanged={this.props.UiStore!.setMultiCalendarSecondPharmacyId}
            />
          </Card>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(CalendarComparisonPage);
